import {
  GET_CLIENT_NOTIFICATIONS_RESPONSE,
  GET_CLIENT_DROPDOWN_NOTIFICATIONS_RESPONSE,
  SET_CLIENT_UNSEEN_NOTIFICATIONS_COUNT,
  REPLACE_CLIENT_NOTIFICATION,
  ADD_CLIENT_PUSH_NOTIFICATION,
} from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  unseenNotificationsCount: 0,
  dropdownNotifications: [],
};

const clientNotifications = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_CLIENT_NOTIFICATIONS_RESPONSE: {
      const notificationsList = [...state.list];
      action.payload.list.forEach((elt) => {
        if (notificationsList.findIndex((el) => el.id === elt.id) === -1) {
          notificationsList.push(elt);
        }
      });
      return {
        ...state,
        list: action.payload.clear
          ? []
          : action.payload.meta.currentPage === 1
          ? [...action.payload.list]
          : [...notificationsList],
        meta: action.payload.meta,
      };
    }
    case REPLACE_CLIENT_NOTIFICATION:
      return {
        ...state,
        list: state.list.map((elt) =>
          elt.id === action.payload.id ? action.payload : elt,
        ),
        dropdownNotifications: state.dropdownNotifications.map((elt) =>
          elt.id === action.payload.id ? action.payload : elt,
        ),
      };
    case ADD_CLIENT_PUSH_NOTIFICATION: {
      const alreadyInList =
        state.list.findIndex((el) => el.id === action.payload.data.id) !== -1;
      const alreadyInDropdown =
        state.dropdownNotifications.findIndex(
          (el) => el.id === action.payload.data.id,
        ) !== -1;
      return {
        ...state,
        list: alreadyInList
          ? state.list
          : [action.payload.data, ...state.list],
        dropdownNotifications: alreadyInDropdown
          ? state.dropdownNotifications
          : [action.payload.data, ...state.dropdownNotifications],
        unseenNotificationsCount: action.payload.badge,
      };
    }
    case SET_CLIENT_UNSEEN_NOTIFICATIONS_COUNT:
      return {
        ...state,
        unseenNotificationsCount: action.payload,
      };
    case GET_CLIENT_DROPDOWN_NOTIFICATIONS_RESPONSE:
      return {
        ...state,
        dropdownNotifications: [...action.payload],
      };
    default:
      return state;
  }
};

export default clientNotifications;
